
const VideoStatus = {
    NORMAL :"",
    UPLOAD :"",
    PLAY:"",
}

export default VideoStatus